<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Freshchat",
  data() {
    return {
      ready: false,
      isOpen: false,
      hideWidget: false,
      externalId: null,
      user: {},
      dom: new HTMLElement()
    };
  },
  methods: {
    onHideWidget() {
      if (!this.dom) return;

      if (this.isOpen) {
        this.dom.style.display = "block";
      } else {
        this.dom.style.display = "none";
      }
    }
  },
  watch: {
    isOpen() {
      if (this.hideWidget) this.onHideWidget();
    },
    hideWidget() {
      if (!this.hideWidget) {
        this.dom.style.display = "block";
        return;
      }

      this.onHideWidget();
    },
    dom() {
      if (this.hideWidget) {
        this.onHideWidget();
      }
    }
  }
});
</script>
